const fallbackApiUrl = process.env.NODE_ENV === 'production'
  ? 'https://api.maintendue.be'
  : 'http://localhost:5000';

const apiUrl = (process.env.REACT_APP_API_URL || fallbackApiUrl).replace(/\/+$/, '');

export async function sendWebsiteEmail(payload) {
  const controller = new AbortController();
  const timeout = window.setTimeout(() => controller.abort(), 15000);

  try {
    const response = await fetch(`${apiUrl}/send-email`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      signal: controller.signal
    });

    const text = await response.text();
    let result = {};

    try {
      result = text ? JSON.parse(text) : {};
    } catch {
      throw new Error('Le serveur a renvoye une reponse invalide.');
    }

    if (!response.ok || !result.success) {
      throw new Error(result.message || `Erreur API (${response.status})`);
    }

    return result;
  } catch (error) {
    if (error.name === 'AbortError') {
      throw new Error('Le serveur met trop de temps a repondre.');
    }
    throw error;
  } finally {
    window.clearTimeout(timeout);
  }
}
